<template>
  <v-row>
    <v-col v-for="(card, index) in feedbacks" :key="index" cols="12" sm="6" md="4">
      <v-card class="elevation-16 mx-auto" width="300">
        <v-card-title class="text-h5">{{ card.name }}</v-card-title>
        <v-card-subtitle >{{ card.date }}</v-card-subtitle>
        <v-card-text>
          {{ card.text }}
          <div class="text-center mt-12">
            <v-rating
              v-model="card.rating"
              color="yellow darken-3"
              background-color="grey darken-1"
              empty-icon="$ratingFull"
              half-increments
              hover
              large
              readonly
            ></v-rating>
          </div>
        </v-card-text>
      </v-card>
    </v-col>

    <v-col cols="12" sm="12">
      <v-card class="elevation-16 mx-auto" width="300">
        <v-card-title class="text-h5">Dejanos tu Comentario</v-card-title>
        <v-card-text>
          <v-form ref="commentForm">
            <v-text-field v-model="newComment.name" label="Nombre" :rules="nameRules"></v-text-field>
            <v-textarea v-model="newComment.text" label="Comentario" :rules="textRules"></v-textarea>
          </v-form>
          <div class="text-center mt-12">
            <v-rating
              v-model="newComment.rating"
              color="yellow darken-3"
              background-color="grey darken-1"
              empty-icon="$ratingFull"
              half-increments
              hover
              large
              :rules="ratingRules"
            ></v-rating>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn @click="save" color="primary">Agregar Comentario</v-btn>
        </v-card-actions>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import feedbacRepository from '@/repository/feedbackRepository'

export default {
  data: () => ({
    rating: 4.5,
    unsubscribe: null,
    newComment: {
      name: "",
      text: "",
      rating: 0,
      date: ""
    },
    feedbacks:[],
    nameRules: [
      v => !!v.trim() || 'El nombre es obligatorio',
    ],
    textRules: [
      v => !!v.trim() || 'El comentario es obligatorio',
    ],
    ratingRules: [
      v => v > 0 || 'Seleccione al menos una estrella',
    ],
  }),
  created() {
    this.getAll();
  },
  methods: {
    async getAll() {
      try {
        const callback = (snapshot) => {
          const feedbacks = [];
          snapshot.forEach((doc) => {
            const feedback = doc.data();
            feedback.id = doc.id;
            feedbacks.push(feedback);
          });

          feedbacks.sort((a, b) => this.compareDates(b.date, a.date));

          this.feedbacks = feedbacks;
        };

        const collectionRef = feedbacRepository.getCollectionRef();  
        this.unsubscribe = feedbacRepository.subscribeToCollection(
          collectionRef,
          callback
        );
      } catch (error) {
        console.log(error);
        this.feedbacks = [];
      }
    },
    compareDates(dateStrA, dateStrB) {
      const dateA = new Date(dateStrA);
      const dateB = new Date(dateStrB);

      if (dateA < dateB) {
        return -1;
      } else if (dateA > dateB) {
        return 1;
      } else {
        return 0;
      }
    },
    clearForm() {
      this.newComment.name = "";
      this.newComment.text = "";
      this.newComment.rating = "";
    },
    async save() {
      if (this.$refs.commentForm.validate()) {
        const feedbackData = {
          name: this.newComment.name.trim(),
          text: this.newComment.text.trim(),
          rating: this.newComment.rating,
          date: new Date().toLocaleString(),
        };
        try {
          await feedbacRepository.save(feedbackData);
          this.clearForm();
        } catch (error) {
          console.error(error);
        }
      } else {
        console.warn('Por favor, complete todos los campos obligatorios.');
      }
    },
  },
};
</script>
